// extracted by mini-css-extract-plugin
export var audioPlayer = "_re-0";